import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSearchIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m15.18 12.73-3.94-3.94A5.945 5.945 0 0 0 5.98.04c-1.4 0-2.8.49-3.93 1.48a5.957 5.957 0 0 0-.55 8.42 5.935 5.935 0 0 0 4.49 2.03c.86 0 1.71-.21 2.51-.58l4.01 4.01c.41.4.93.61 1.45.61.48 0 .95-.18 1.3-.53.73-.73.7-1.97-.08-2.75Zm-9.19-2.01c-1.36 0-2.65-.59-3.55-1.61a4.702 4.702 0 0 1-1.16-3.42c.08-1.26.65-2.41 1.6-3.24.86-.75 1.96-1.17 3.11-1.17 1.36 0 2.65.59 3.55 1.61.83.95 1.24 2.16 1.16 3.42a4.667 4.667 0 0 1-1.6 3.24c-.87.76-1.97 1.17-3.11 1.17Zm8.38 3.88c-.25.25-.69.22-.98-.08L9.6 10.73c.11-.08.22-.15.32-.23.23-.2.42-.42.6-.65l3.77 3.77c.29.29.33.73.08.98Z",
    fill: "currentColor"
  }));
}

export { SvgSearchIcon as default };
